export const getDrugManufacturers = (products: any[], drugManufacturer: any[]): string => {
    const allIds = products?.flatMap((product) => {
        // ✅ Solo procesar productos SIN drugManufacturerIdSelected
        if (
            product?.drugManufacturerIdSelected &&
            Array.isArray(product.drugManufacturerIdSelected) &&
            product.drugManufacturerIdSelected.length > 0
        ) {
            return []; // saltar este product
        }

        // Productos directos válidos
        const directProducts = Object.values(product?.products || {}).filter(
            (p: any) => p && typeof p === 'object' && !Array.isArray(p) && p.drug_manufacturer_id != null,
        );

        // Productos genéricos válidos
        const generics = Array.isArray(product?.products?.generics)
            ? product.products.generics
                  .map((g) => g?.product)
                  .filter((p) => p && typeof p === 'object' && p.drug_manufacturer_id != null)
            : [];

        const allValidProducts = [...directProducts, ...generics];

        return allValidProducts.map((p) => p.drug_manufacturer_id);
    });

    // ✅ Eliminar duplicados
    const uniqueIds = [...new Set(allIds)];

    // ✅ Buscar nombres
    const uniqueNames = drugManufacturer?.filter((f) => uniqueIds.includes(f.id)).map((f) => f.name);

    return uniqueNames.join(', ');
};
